import { createRef } from "react";
import { initSocialBanner } from "Pages/Components/SocialBanner/initSocialBanner";
import { init as initBanner } from "./ClaimYourProfile/Banner/init";
import { init as initBadge } from "./ClaimYourProfile/Badge/init";
import { init as initNotAvailableBox } from "./NotAvailableBox/init";
import { initLegacy } from "./initLegacy";
import { init as initSpacesYouMayAlsoLike } from "./SpacesYouMayAlsoLike/init";
import { init as initVerifiedEmailPopUp } from "./VerifiedEmailPopUp/init";
import { BenefitPopUpRef, init as initBenefitPopUp } from "./ClaimProfilePopUp";

import "Validation/yup/methods";
import "Styles/Pages/XPP/xpp.scss";

declare global {
   interface Window {
      xppModel?: Readonly<LSCommon.Service.LSWebUI.Models.XPP.XppLandingPageJsViewModel>
      xppViewModel?: XPP.ViewModel;
   }
}

const benefitPopupRef = createRef<BenefitPopUpRef>();

const model = window.xppModel;

if (!model) {
   throw new Error("XPP model not found");
}

initLegacy(model);

function showClaimForm() {
   benefitPopupRef.current?.toggle();
}

initBenefitPopUp(model, benefitPopupRef);

initBanner(model, showClaimForm);

initBadge(model, showClaimForm);

initNotAvailableBox(model, showClaimForm);

initSpacesYouMayAlsoLike(model);

initVerifiedEmailPopUp(model);

if(model.EnterpriseAccountId && model.EnterpriseSocialActivityEnabled)
   initSocialBanner(model.EnterpriseAccountId, model.VenueId, "xpp-top-social-banner")